module.exports = __webpack_public_path__ + "media/images/left-arrow-849fc4a2eb9c3c5100e05e72d43214d9.svg";